<header>
  <a routerLink="/" class="homepage-link">
    <img src="assets/img/svg/emp-logo.svg" alt="EMP Logo" />
  </a>

  <emp-solutions-menu class="show-desktop" />

  @if (showAccounts) {
    <mat-form-field subscriptSizing="dynamic">
      <mat-label> {{ 'ACCOUNT' | translate }} </mat-label>
      <mat-select
        #accountSelect
        [ngModel]="currentAccount()"
        (selectionChange)="onAccountChange($event.value); accountSelect.panel.nativeElement.style.visibility = 'hidden'"
        (opened)="focusAccountSearch(accountSearchInput)"
        (closed)="accountSearch.set('')"
      >
        <div class="search-select">
          <input
            #accountSearchInput
            matInput
            (keydown)="$event.stopPropagation()"
            [(ngModel)]="accountSearch"
            [placeholder]="'SEARCH' | translate"
          />
          <span class="material-symbols-rounded-m gray">search</span>
        </div>

        @for (account of filteredAccounts(); track account.id) {
          <mat-option [value]="account.id">
            {{ account.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <button [matMenuTriggerFor]="accountMenu" class="reset menu-button show-desktop">
    <span class="material-symbols-rounded-m">person</span>
    {{ 'ACCOUNT' | translate }}
    <span class="material-symbols-rounded-m">arrow_drop_down</span>
  </button>

  <button [matMenuTriggerFor]="languagesMenu" class="reset menu-button show-desktop">
    {{ languageService.language() | uppercase }}
    <span class="material-symbols-rounded-m">arrow_drop_down</span>
  </button>

  <button [matMenuTriggerFor]="mobileAccountMenu" class="reset menu-button show-mobile">
    <span class="material-symbols-rounded-m">menu</span>
    {{ 'MENU' | translate }}
  </button>
</header>

<mat-menu #accountMenu="matMenu" xPosition="before">
  <emp-account-menu />
</mat-menu>

<mat-menu #languagesMenu="matMenu" xPosition="before">
  <emp-language-menu />
</mat-menu>

<mat-menu #mobileAccountMenu="matMenu" xPosition="before">
  <emp-mobile-account-menu />
</mat-menu>
